var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrosshair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75269 5.26483C5.90829 5.10942 6.11921 5.02213 6.33912 5.02213C6.55903 5.02213 6.76995 5.10942 6.92555 5.26483L10.4884 8.82764L14.0512 5.26483C14.1526 5.15559 14.2816 5.07574 14.4246 5.03368C14.5676 4.99161 14.7193 4.9889 14.8638 5.02583C15.0082 5.06276 15.14 5.13795 15.2452 5.24349C15.3505 5.34904 15.4254 5.48102 15.4619 5.62553C15.4989 5.76979 15.4963 5.92135 15.4545 6.06426C15.4126 6.20717 15.333 6.33617 15.224 6.43768L11.6612 10.0005L15.224 13.5633C15.3333 13.6647 15.4131 13.7938 15.4552 13.9368C15.4972 14.0798 15.5 14.2315 15.463 14.3759C15.4261 14.5203 15.3509 14.6521 15.2454 14.7574C15.1398 14.8626 15.0078 14.9375 14.8633 14.9741C14.7191 15.011 14.5675 15.0084 14.4246 14.9666C14.2817 14.9247 14.1527 14.8451 14.0512 14.7362L10.4884 11.1733L6.92555 14.7362C6.76814 14.8827 6.56007 14.9624 6.34506 14.9587C6.13006 14.955 5.92486 14.8681 5.77261 14.7162C5.62076 14.564 5.53384 14.3588 5.53012 14.1438C5.52641 13.9288 5.60619 13.7207 5.75269 13.5633L9.31551 10.0005L5.75269 6.43768C5.59729 6.28208 5.51 6.07116 5.51 5.85125C5.51 5.63134 5.59729 5.42042 5.75269 5.26483Z",
    fill: "#FEB2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosshair);
export default __webpack_public_path__ + "static/media/Crosshair.6bfc40c35c05341f69189aba309194fc.svg";
export { ForwardRef as ReactComponent };